/* eslint-disable no-console */
import { settings } from './settings';

export const info = ( message ) => {
	if ( settings.INFO_ENABLED ) {
		console.info( message );
	}
};

export const debug = ( message ) => {
	if ( settings.DEBUG_ENABLED ) {
		if ( window.location.href !== window.top.location.href ) {
			console.debug( 'DEBUG [ ' + window.location.href + ' ]' );
		}
		if ( typeof message !== 'object' ) {
			console.debug( 'DEBUG: ' + message );
		} else {
			console.debug( message );
		}
	}
};

export const debounce = ( fn, wait ) => {
	let timer;
	return function( ...args ) {
		if ( timer ) {
			clearTimeout( timer );
		}
		const context = this;
		timer = setTimeout( () => {
			fn.apply( context, args );
		}, wait );
	};
};
